// Versión y fecha de los documentos legales públicos (Aviso de Privacidad Integral y
// Términos y Condiciones). Única fuente de verdad para que ambas páginas y el registro
// muestren siempre el mismo dato. Cambiar aquí cuando el PO publique una nueva versión.
export const VERSION_LEGAL = "2026-10-16";
export const FECHA_ACTUALIZACION_LEGAL = "16 de octubre de 2026";
